import { render, staticRenderFns } from "./VDesignSendForCheckingModal.vue?vue&type=template&id=39ff20b4&"
import script from "./VDesignSendForCheckingModal.vue?vue&type=script&lang=ts&"
export * from "./VDesignSendForCheckingModal.vue?vue&type=script&lang=ts&"
import style0 from "./VDesignSendForCheckingModal.vue?vue&type=style&index=0&id=39ff20b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports